import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import _ from 'lodash';

dayjs.extend(isBetween);

export const filterRateSheetByDate =
  (start, end) =>
  ({ title }) => {
    const dateRegExp = new RegExp(/[\d]{1,2}\/[\d]{1,2}\/[\d]{4}/, 'ig');

    const matchedDateStr = _.head(title?.match(dateRegExp));

    return !!matchedDateStr && dayjs(matchedDateStr).isBetween(start, end, 'day', '[]');
  };
